import { render, staticRenderFns } from "./CoreView.vue?vue&type=template&id=5ef077d3&"
import script from "./CoreView.vue?vue&type=script&lang=ts&"
export * from "./CoreView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports